import { tEngine } from "../../../i18n/engine";
import { t } from "../../../i18n";
import { CASE_LABEL, fmt, type CaseId, type WallResult } from "@tasduvar/engine";
import { Section, Verdict } from "./common";

export function Joints({ result }: { result: WallResult }): JSX.Element {
  return (
    <Section id="joints" title={t("12. İç Kesit (Derz) Kontrolleri")}>
      {result.joints.length === 0 ? <p className="muted">{t("Kontrol edilecek iç kesit yok (tek kademe, ek kot tanımlanmadı).")}</p> : (
        <table>
          <thead><tr><th>{t("Kesit")}</th><th>{t("Durum")}</th><th className="num">b (m)</th><th className="num">{t("N (kN/m)")}</th><th className="num">{t("V (kN/m)")}</th><th className="num">e (m)</th><th className="num">{t("e_lim (m)")}</th><th className="num">{t("σmax (kN/m²)")}</th><th className="num">{t("Kayma GK")}</th><th>{t("Sonuç")}</th></tr></thead>
          <tbody>
            {result.joints.flatMap((j) => (Object.keys(j.cases) as CaseId[]).map((cid) => { const c = j.cases[cid]!; return (
              <tr key={`${j.level}-${cid}`}><td>{tEngine(j.label)}</td><td>{tEngine(CASE_LABEL[cid])}</td><td className="num">{fmt(j.width, 3)}</td><td className="num">{fmt(c.N)}</td><td className="num">{fmt(c.V)}</td><td className="num">{fmt(c.e, 3)}</td><td className="num">{fmt(c.eLimit, 3)}</td><td className="num">{fmt(c.sigmaMax)}</td><td className="num">{fmt(c.shearFactor, 2)} / {fmt(c.shearTarget, 2)}</td><td><Verdict ok={c.ok} /></td></tr>
            ); }))}
          </tbody>
        </table>
      )}
    </Section>
  );
}
